module.exports = "/assets/data/c5d75b064664535f3ab64817b2bdb178-SS7.data.json";